import {
    useMemo,
} from 'react'

import {
    ModificationRequiredContainersType,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import requests from 'app/requests/Order/ContainersBooking.requests'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'

import columns from './requiredContainersChanges.columns'
import useStyles from './RequiredContainersChanges.style'

const RequiredContainersChanges = ({
    orderNumber,
}: { orderNumber: string }) => {
    const {
        classes,
    } = useStyles()

    const urlConfig = useMemo(() => {
        const url = requests.getRequiredContainersChanges({
            orderNumber,
        })

        return {
            customUrl: url.url,
            method: url.method,
            name: 'RequiredContainersChanges',
        }
    }, [orderNumber])

    const load: (params: any) => Promise<{
        items: ModificationRequiredContainersType[],
        matches: number,
    }> = useLoadDtoForSkyNetTable(
        urlConfig,
    )

    return (
        <RichTable
            configName="RequiredContainersChangesTable"
            name="RequiredContainersChanges"
            load={load}
            columns={columns}
            className={classes.tableContent}
            classNames={{
                contentWrapper: classes.tableContentWrapper,
            }}
            uniqField="id"
        />
    )
}

export default RequiredContainersChanges
